// extracted by mini-css-extract-plugin
export default {"productdetail":"ProductDetail_productdetail__L7AW5","HomeBtn":"ProductDetail_HomeBtn__SGrOF"};